export default {
  errorLogs: [],
  loading: false,
};
